import { toast } from 'material-react-toastify';

import { coachApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { useCoachCabinetStore } from '@/lib/store/coachCabinetStore';
import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';

export const useCoachData = () => {
  return useMutation({
    mutationFn: async (email: string) => {
      const token = await getAuthToken();
      const { data: coach } = await coachApi.searchCoach(email, withAuthHeader(token));
      return coach;
    },
    onSuccess: (coach) => {
      if (coach) {
        useCoachCabinetStore.setState({ coach });
      }
    },
    onError: (error) => {
      Sentry.captureException(`Failed to fetch coach data: ${error.message}`);
      toast.error(error.message);
    },
  });
};
